export const PROFIT_MODES = {
    CLASSIC: 'classic',
    LET_RUN: 'let_run'
};

export const PROFIT_PROFILES = {
    classic: {
        id: PROFIT_MODES.CLASSIC,
        armProfit: 1.2,
        giveback: 1.2,
        reversal: 'or',
        reversalMinProfit: 1.2
    },
    let_run: {
        id: PROFIT_MODES.LET_RUN,
        armProfit: 1.2,
        giveback: 1.2,
        reversal: 'and',
        reversalMinProfit: 2.5
    }
};

export function formatProfitPct(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return String(value ?? '');
    return String(number).replace('.', ',');
}

export function resolveProfitProfile(source) {
    if (source && typeof source === 'object') {
        if (source.profitProfile && typeof source.profitProfile === 'object' && source.profitProfile !== source)
            return resolveProfitProfile(source.profitProfile);
        const mode = source.profitMode || source.predadorProfitMode
            || (source.id === PROFIT_MODES.LET_RUN || source.id === PROFIT_MODES.CLASSIC ? source.id : null);
        if (mode === PROFIT_MODES.LET_RUN || mode === PROFIT_MODES.CLASSIC) {
            const base = PROFIT_PROFILES[mode];
            const armProfit = Number(source.armProfit);
            const giveback = Number(source.giveback);
            const reversalMinProfit = Number(source.reversalMinProfit);
            return {
                ...base,
                id: mode,
                armProfit: Number.isFinite(armProfit) ? armProfit : base.armProfit,
                giveback: Number.isFinite(giveback) ? giveback : base.giveback,
                reversal: source.reversal === 'and' || source.reversal === 'or' ? source.reversal : base.reversal,
                reversalMinProfit: Number.isFinite(reversalMinProfit) ? reversalMinProfit : base.reversalMinProfit
            };
        }
    }
    const mode = source === PROFIT_MODES.LET_RUN ? PROFIT_MODES.LET_RUN : PROFIT_MODES.CLASSIC;
    return PROFIT_PROFILES[mode];
}

export function profitModeHelp(source) {
    const profile = resolveProfitProfile(source);
    if (profile.id === PROFIT_MODES.LET_RUN)
        return `Livre após ${formatProfitPct(profile.armProfit)}% (cobre as taxas). O piso acompanha o pico (${formatProfitPct(profile.giveback)}% abaixo). A reversão só vende se MACD e EMA reverterem juntos, e só depois de ${formatProfitPct(profile.reversalMinProfit)}% de lucro. Até lá, só o piso móvel vende. Stop de prejuízo só vale antes de armar.`;
    return `Livre após ${formatProfitPct(profile.armProfit)}% (cobre as taxas). Depois o piso acompanha o pico: se cair ${formatProfitPct(profile.giveback)}% do topo, vende. MACD ou EMA também vendem se reverterem. Stop de prejuízo só vale antes de armar.`;
}

export function profitModeShort(source) {
    const profile = resolveProfitProfile(source);
    if (profile.id === PROFIT_MODES.LET_RUN)
        return `mín. ${formatProfitPct(profile.armProfit)}% · reversão exigente (${formatProfitPct(profile.reversalMinProfit)}%)`;
    return `mín. ${formatProfitPct(profile.armProfit)}% · piso móvel`;
}

export function reversalNeedsBoth(source) {
    return resolveProfitProfile(source).reversal === 'and';
}
